<template>
  <section class="app-main">
    <transition
name="fade-transform"
mode="out-in">
      <router-view
:key="key"
class="p-2" />
    </transition>
  </section>
</template>

<script>
export default {
  name: "AppMain",
  computed: {
    key() {
      return this.$route.path;
    },
  },
};
</script>

<style lang="scss" scoped>
.app-main {
  min-height: calc(100vh - 64px);
  width: calc(100% - 28px);
  position: relative;
  overflow: hidden;
  padding: 14px;
}

.fixed-header + .app-main {
  padding-top: 50px;
}

.hasTagsView {
  .app-main {
    /* 84 = navbar + tags-view = 50 + 34 */
    min-height: calc(100vh - 64px);
  }

  .fixed-header + .app-main {
    padding-top: 64px;
  }
}
</style>

<style lang="scss">
// fix css style bug in open el-dialog
.el-popup-parent--hidden {
  .fixed-header {
    padding-right: 15px;
  }
}
</style>
